export const colors = {
    name: 'Colors',
    fields: []
};